import { generateFocusColors } from "@canucci/base-mantine/colors";
import {
  brandColorTokens,
  createBaseResolver,
  createBaseTheme,
  defaultBrandColors,
  defaultBrandFontFamily,
  lightTealNotificationStyles,
} from "@canucci/base-mantine/theme";
import { Notification } from "@mantine/core";

export const theme = createBaseTheme({
  fontFamily: defaultBrandFontFamily,
  headings: {
    fontFamily: defaultBrandFontFamily,
  },
  colors: {
    ...defaultBrandColors,
    ...generateFocusColors(),
  },
  primaryColor: "primary",
  components: {
    Notification: Notification.extend({
      styles: lightTealNotificationStyles,
    }),
  },
  other: {
    semanticColors: {
      background: brandColorTokens.pageBackground,
      text: brandColorTokens.bodyText,
      fgOnDarkDim: brandColorTokens.fgOnDarkDim,
    },
  },
});

export const resolver = createBaseResolver();
